import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { useTranslation } from 'react-i18next';

import { getUnsubscribeReasons } from 'store/unsubscribe-reasons/actions';
import { unsubscribeReasonsSelector } from 'store/unsubscribe-reasons/selectors';

import { usePagination } from 'hooks/usePagination';

import { getTranslation } from 'helpers/getTranslation';

import StudentsUnsubscribeReasons from './StudentsUnsubscribeReasons';

const StudentsUnsubscribeReasonsContainer = () => {
  const dispatch = useAppDispatch();
  const { i18n } = useTranslation();

  const {
    data: unsubscribeReason,
    currentPage,
    totalPages,
    perPage,
  } = useAppSelector(unsubscribeReasonsSelector);

  const [loading, setLoading] = useState(true);

  const [sortParams, setSortParams] = useState({
    sortBy: {
      label: getTranslation('inbox_page.action.date'),
      value: 'createdAt',
    },
    sortDirection: 'desc',
  });

  useEffect(() => {
    const _getUnsubscribeReasons = async () => {
      try {
        await dispatch(
          getUnsubscribeReasons({
            page: 1,
            limit: perPage,
            sortBy: sortParams.sortBy.value,
            sortDirection: sortParams.sortDirection,
          }),
        ).unwrap();
      } catch (error) {
        console.warn(error);
      }

      setLoading(false);
    };

    _getUnsubscribeReasons();
  }, [sortParams]);

  const handleSortChange = (values: any) => {
    setSortParams((prevState: any) => ({
      ...prevState,
      ...values,
    }));
  };

  const [onPerPageChange, onPrevPageClick, onNextPageClick] = usePagination({
    dataAction: getUnsubscribeReasons,
    currentPage,
    totalPages,
    perPage,
    sortBy: sortParams.sortBy.value,
    sortDirection: sortParams.sortDirection,
  });

  return (
    <StudentsUnsubscribeReasons
      locale={(i18n as any).locale}
      loading={loading}
      reasons={unsubscribeReason}
      currentPage={currentPage}
      totalPages={totalPages}
      perPage={perPage}
      sortParams={sortParams}
      onPerPageChange={onPerPageChange}
      onPrevPageClick={onPrevPageClick}
      onNextPageClick={onNextPageClick}
      onSortChange={handleSortChange}
    />
  );
};

export default React.memo(StudentsUnsubscribeReasonsContainer) as any;
